<template>
  <div class="containerHome"></div>
</template>

<script>
export default {
  methods: {
    handleToPath(path) {
      this.$router.push(path)
    }
  },
  mounted() {
    const domainName = window.location.hostname
    // vava
    if (domainName == 'app.camfan.chat' || domainName == 'app.test.camfan.chat') {
      let path = 'https://www.camfan.chat/#/home'
      window.open(path, '_self')
    }
    // joychat
    else if (domainName == 'app.joyme.chat' || domainName == 'd3iaj0r7mc0gy4.cloudfront.net') {
      let path = 'https://www.joyme.chat/#/home'
      window.open(path, '_self')
    }
    // goparty
    else if (domainName == 'web.goparty.tech') {
      let path = 'https://www.goparty.tech/'
      window.open(path, '_self')
    }
  }
}
</script>
<style lang="scss" scoped>
.containerHome {
  width: 100%;
  height: 100vh;
  background-color: #999;
  padding: 15px 15px;
  .title {
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  button {
    height: 30px;
    padding: 0 8px;
    margin: 5px;
  }
}
</style>
